import React from "react";

import { LinkOut } from "icons";

import { Button } from "clearsense-ui/components";
import getFullAddress from "utils/getFullAddress";

import { ADDRESS_VALUE_SEPARATORS } from "../../constants";

const Address = ({ values }) => (
  <>
    {getFullAddress(values, ADDRESS_VALUE_SEPARATORS)}
    <br />
    <br />
    <Button
      label="View Map"
      style="link"
      size="default"
      icon={LinkOut}
      iconPosition="left"
      href={`https://maps.google.com?q=${values.slice(0, -2).join(" ")}`}
    />
  </>
);

export default Address;
